import React, { useState } from 'react';
import { SearchStyle } from './Search.style';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Search() {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [searchResults, setSearchResults] = useState([]);
    const [searchMode, setSearchMode] = useState('search'); // 'search' or 'all'
    const navigate = useNavigate();

    const submitForm = async (data) => {
        const parts = data.user.split(' ');
        const firstname = parts[0];
        const lastname = parts.slice(1).join(' ');

        try {
            const url =
                searchMode === 'all'
                    ? `https://api.agrop.eu/getAllFarmers`
                    : !isNaN(data.user)
                        ? `https://api.agrop.eu/search?cvr=${data.user}`
                        : `https://api.agrop.eu/search?firstName=${firstname}&lastName=${lastname}`;

            const response = await axios.get(url);
            setSearchResults(response.data);
        } catch (error) {
            console.error("Error fetching search results:", error);
        }
    };

    return (
        <SearchStyle>
            {!searchResults && (
                <h2 style={{ position: "absolute", left: "50vw", top: "40vh", right: "50vh" }}>
                    Gør tingene klar...
                </h2>
            )}
<form
  onSubmit={(e) => {
    e.preventDefault(); // prevent double submit
    handleSubmit(submitForm)(e);
  }}
>
  <input
    type="text"
    name="user"
    id="user"
    placeholder="Søg.."
    {...register('user')}
    onKeyDown={(e) => {
      if (e.key === 'Enter') {
        setSearchMode('search'); // force 'search' on Enter key
      }
    }}
  />
  {errors.user && <span>Du kan ikke søge på ingenting!</span>}

  {/* Hidden default submit button to prevent defaulting to "Vis alle" */}
  <button type="submit" style={{ display: 'none' }} aria-hidden="true"></button>

  <article>
    <button
      type="reset"
      onClick={() => {
        setSearchResults([]);
      }}
    >
      Slet alt
    </button>

    <button
      type="submit"
      onClick={() => {
        setSearchMode('all');
      }}
    >
      Vis alle
    </button>

    <button
      type="submit"
      onClick={() => {
        setSearchMode('search');
      }}
    >
      Søg
    </button>
  </article>
</form>

            <h2>Resultater</h2>
            <section className="result">
                {searchResults.length > 0 ? (
                    searchResults.map((item, index) => (
                        <p key={index} onClick={() => navigate(`/clientlookup/${item.id}`)}>
                            {item.firstname} {item.lastname}
                        </p>
                    ))
                ) : (
                    <h2 style={{ borderBottom: "solid white 2px" }}>Intet resultat</h2>
                )}
            </section>
        </SearchStyle>
    );
}

export default Search;
